import { get, post, put, del } from "../request";

/** 分页查询用户列表 */
export function userList(params) {
  return get("/education-system/user/list", params);
}

/** 新增用户 */
export function userSave(params) {
  return post("/education-system/user", params);
}

/** 修改用户 */
export function userUpdate(params) {
  return put("/education-system/user", params);
}

/** 查询用户详情 */
export function userInfo(id) {
  return get(`/education-system/user/${id}`);
}

/** 删除用户 */
export function userDelete(id) {
  return del(`/education-system/user/${id}`);
}

/** 重置用户密码 */
export function userPwd(params) {
  return put("/education-system/user/resetPwd", params);
}

/** 修改用户状态（启用/停用） */
export function userLock(params) {
  return put("/education-system/user/changeStatus", params);
}



// WEBPACK FOOTER //
// ./src/api/system/user.js